import React, { useEffect, useState, useRef } from "react"
import * as endpoints from "../../api/endpoints"
import Slider from "react-slick"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"
import Svg from "../_svgs/svg"
import { DateTime } from "luxon"
import * as date from "../../booking/helpers/date"
import MerchantItem from "../merchant/merchant-item/merchant-item"

export const ItineraryContentBlockCarousel = ({ block, flightInfo, tabToggle, showMerchantInfoModal, estimatedPublicTime }) => {
  const [slides, setSlides] = useState([])
  const [filteredSlides, setFilteredSlides] = useState([])
  const [carouselCategories, setCarouselCategories] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])

  const lang = (document.body && document.body.dataset.language) || "da"
  const sliderRef = useRef(null)

  useEffect(() => {
    if (block) {
      getCarouselItems()
      if (!block.hideCategoryFilters) {
        getCarouselCategories()
      }
    }
  }, [])

  const getCarouselItems = async () => {
    const { categoryReferences, useActive, amountToShow } = block
    const categoryIds = categoryReferences?.join(",") || ""
    const data = { categoryIds: categoryIds, language: lang, useActive: useActive, estimatedPublicTime: estimatedPublicTime, gate: flightInfo.Gate }
    if (amountToShow > 0) {
      const carouselItemsResponse = await endpoints.getMerchantCarouselItems(data)
      if (carouselItemsResponse && carouselItemsResponse.data) {
        setSlides(carouselItemsResponse.data)
        setFilteredSlides(carouselItemsResponse.data)
      }
    }
  }

  const getCarouselCategories = async () => {
    const data = { categoryIds: block.categoryReferences?.join(",") || "", language: lang }
    const categoryResponse = await endpoints.getMerchantCategoryList(data)
    if (categoryResponse && categoryResponse.data) {
      setCarouselCategories(categoryResponse.data)
    }
  }

  const handleCTATracking = () => {
    trackTravelPlannerInteraction(tabToggle, "button_click", { button_text: block?.buttonText })
  }

  const toggleCategory = (category) => {
    let categories = selectedCategories
    if (categories.includes(category)) {
      const prevCategories = categories
      categories = prevCategories.filter((item) => {
        return item !== category
      })
    } else {
      categories = [...selectedCategories, category]
    }
    let filteredSlides = filterSlides(categories)
    if (filteredSlides.length < 1) filteredSlides = slides
    setSelectedCategories(categories)
    setFilteredSlides(filteredSlides)
  }

  const filterSlides = (selectedCategories) => {
    if (selectedCategories.length > 0) {
      const filteredSlides = slides.filter((merchant) => merchant.MerchantCategoriesList.some((category) => selectedCategories.includes(category)))
      sliderRef.current.slickGoTo(0, true)
      return filteredSlides
    } else {
      return slides
    }
  }
  var settings = {
    dots: false,
    arrows: true,
    speed: 150,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 550,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  }

  const dtLocale = date.luxonLocale(flightInfo.language)
  const zone = "Europe/Copenhagen"
  const luxonToday = DateTime.now().setLocale(dtLocale).setZone(zone)

  const isFlightDateOlderThanToday =
    estimatedPublicTime.day > luxonToday.day || estimatedPublicTime.month > luxonToday.month || estimatedPublicTime.year > luxonToday.year

  // setting an array of jsx elements to provide sorting logic later in state.
  useEffect(() => {
    setFilteredSlides(slides?.slice(0, block.amountToShow))
  }, [slides])

  let carouselItems = filteredSlides?.map((slide, i) => {
    if (!slide) return
    if (i >= block.amountToShow) return
    return (
      <CarouselItem
        key={i}
        alwaysOpen={slide.AlwaysOpen}
        alwaysOpenLabel={slide.AlwaysOpenLabel}
        closedLabel={slide.ClosedLabel}
        closingLabel={slide.ClosingLabel}
        img={slide.Image}
        categories={slide.MerchantCategoriesList}
        merchantDescription={slide.MerchantDescription}
        merchantEmail={slide.MerchantEmail}
        merchantIsNearGate={slide.MerchantIsNearGate}
        isRibbonValid={slide.IsRibbonValid}
        isInnerSlide={false}
        link={slide.MerchantLink}
        merchantNumber={slide.MerchantNumber}
        merchantPhone={slide.MerchantPhone}
        name={slide.Name}
        emailCoverLabel={slide.EmailCoverLabel}
        nearGateSplashLabel={slide.NearGateSplashLabel}
        shopLocation={slide.ShopLocation}
        openLabel={slide.OpenLabel}
        openingLabel={slide.OpeningLabel}
        openingHours={slide.OpeningHours}
        supportsClickAndCollect={slide.SupportsClickAndCollect}
        supportsHomeDelivery={slide.SupportsHomeDelivery}
        homeDeliveryLabel={slide.HomeDeliveryLabel}
        websiteAdress={slide.WebsiteAdress}
        flightGate={flightInfo.Gate}
        readMoreLabel={slide.ReadMoreLabel}
        language={lang}
        readLessLabel={slide.ReadLessLabel}
        findAllLabel={slide.FindAllLabel}
        clickAndCollectLabel={slide.ClickAndCollectLabel}
        weekdays={slide.Weekdays}
        showMerchantInfoModal={showMerchantInfoModal}
        sameMerchants={slides.filter((slides) => slide.Name === slides.Name && slide.MerchantNumber !== slides.MerchantNumber)}
        clickTracking={slide.clickTrackingRR}
        flightId={flightInfo.FlightId}
        tabToggle={tabToggle}
        estimatedPublicTime={estimatedPublicTime}
        isFlightDateOlderThanToday={isFlightDateOlderThanToday}
        itineraryComponent={slide.ItineraryComponent}
        googleMapsLink={slide.GoogleMapsLink}
        googleMapsLinkLabel={slide.GoogleMapsLinkLabel}
        googleMapsLinkTarget={slide.GoogleMapsLinkTarget}
      />
    )
  })

  return filteredSlides && filteredSlides.length > 0 ? (
    <div className={`departure-info__essentials__detailitems__detailitem__carousel`}>
      <h5 className="merchanttype">{block?.headline || "Spisesteder"}</h5>
      <div className="checkmarktags">
        {carouselCategories.length > 1 &&
          carouselCategories.map((category, index) => {
            if (!slides.some((slide) => slide.MerchantCategoriesList.includes(category))) return ""
            return (
              <span key={index}>
                <input id={category} type="checkbox" onClick={() => toggleCategory(category)} />
                <label htmlFor={category}>
                  <Svg iconName={"tagcheck"} />
                  {category}
                </label>
              </span>
            )
          })}
      </div>
      <Slider ref={sliderRef} {...settings}>
        {carouselItems}
        <a href={block?.buttonLink ? `${block?.buttonLink}` : undefined}>
          <div className="slide-inner--more">
            <Svg iconName={"PlusIcon"} />
            <div className="text">{block?.buttonText || "Find åbne butikker og spisesteder"}</div>
          </div>
        </a>
      </Slider>
      <a className="viewalllink" href={block?.buttonLink ? `${block?.buttonLink}` : undefined} onClick={() => handleCTATracking()}>
        <span className="text">{block?.buttonText || "Find åbne butikker og spisesteder"}</span>
      </a>
    </div>
  ) : (
    ""
  )
}

export const CarouselItem = ({
  tabToggle,
  link,
  name,
  img,
  sameMerchants,
  flightGate,
  nearGateSplashLabel,
  categories,
  merchantDescription,
  merchantEmail,
  showMerchantInfoModal,
  shopLocation,
  emailCoverLabel,
  merchantNumber,
  merchantPhone,
  openingHours,
  closedLabel,
  language,
  isRibbonValid,
  alwaysOpen,
  alwaysOpenLabel,
  merchantIsNearGate,
  openLabel,
  supportsClickAndCollect,
  websiteAdress,
  estimatedPublicTime,
  isInnerSlide = false,
  clickAndCollectLabel,
  readMoreLabel,
  readLessLabel,
  findAllLabel,
  openingLabel,
  closingLabel,
  weekdays,
  homeDeliveryLabel,
  supportsHomeDelivery,
  isFlightDateOlderThanToday,
  itineraryComponent,
  googleMapsLink,
  googleMapsLinkLabel,
  googleMapsLinkTarget,
}) => {
  const handleClickTracking = () => {
    trackTravelPlannerInteraction(tabToggle, "card_click", { card_url: link })
  }

  const handleClickElement = (event) => {
    // When in inner modal slider, navigate to link.
    if (!isInnerSlide) event.preventDefault()

    showMerchantInfoModal({
      tabToggle: tabToggle,
      link: link,
      name: name,
      img: img,
      categories: categories,
      merchantDescription: merchantDescription,
      merchantEmail: merchantEmail,
      merchantNumber: merchantNumber,
      merchantPhone: merchantPhone,
      supportsClickAndCollect: supportsClickAndCollect,
      supportsHomeDelivery: supportsHomeDelivery,
      homeDeliveryLabel: homeDeliveryLabel,
      websiteAdress: websiteAdress,
      alwaysOpen: alwaysOpen,
      alwaysOpenLabel: alwaysOpenLabel,
      flightGate: flightGate,
      isRibbonValid: isRibbonValid,
      merchantIsNearGate: merchantIsNearGate,
      nearGateSplashLabel: nearGateSplashLabel,
      shopLocation: shopLocation,
      emailCoverLabel: emailCoverLabel,
      openingHours: openingHours,
      openLabel: openLabel,
      openingLabel: openingLabel,
      closedLabel: closedLabel,
      closingLabel: closingLabel,
      readMoreLabel: readMoreLabel,
      readLessLabel: readLessLabel,
      findAllLabel: findAllLabel,
      clickAndCollectLabel: clickAndCollectLabel,
      sameMerchants: sameMerchants,
      estimatedPublicTime: estimatedPublicTime,
      weekdays: weekdays,
      isFlightDateOlderThanToday: isFlightDateOlderThanToday,
      googleMapsLink: googleMapsLink,
      googleMapsLinkLabel: googleMapsLinkLabel,
      googleMapsLinkTarget: googleMapsLinkTarget,
    })
    handleClickTracking()
  }

  const openingHoursForTheDay =
    openingHours &&
    [
      openingHours.SundayOpening,
      openingHours.MondayOpening,
      openingHours.TuesdayOpening,
      openingHours.WednesdayOpening,
      openingHours.ThursdayOpening,
      openingHours.FridayOpening,
      openingHours.SaturdayOpening,
    ][estimatedPublicTime.weekday]
  const closingHoursForTheDay =
    openingHours &&
    [
      openingHours.SundayClosing,
      openingHours.MondayClosing,
      openingHours.TuesdayClosing,
      openingHours.WednesdayClosing,
      openingHours.ThursdayClosing,
      openingHours.FridayClosing,
      openingHours.SaturdayClosing,
    ][estimatedPublicTime.weekday]
  return (
    <MerchantItem
      link={link}
      handleClickElement={handleClickElement}
      splashLabel={merchantIsNearGate ? nearGateSplashLabel : null}
      image={img}
      name={name}
      shopLocation={shopLocation}
      isRibbonValid={isRibbonValid}
      alwaysOpen={alwaysOpen}
      alwaysOpenLabel={alwaysOpenLabel}
      openingHoursForTheDay={openingHoursForTheDay}
      closingHoursForTheDay={closingHoursForTheDay}
      itineraryComponent={itineraryComponent}
    />
  )
}
